import { baseApi } from './base.api';
import { ACCOUNTS_URL, API_VERSION } from '../constants/api-routes';

export const accountsService = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getAccounts: build.query<any, { account?: number | string } | void>({
      query: (params?: { account?: number | string }) => ({
        url: `${API_VERSION.V1}/${ACCOUNTS_URL}`,
        params: {
          ...(params && params.account !== '' && { account: params.account }),
        },
      }),
      providesTags: ['Accounts'],
    }),
    updateAccounts: build.mutation({
      query: (body) => ({
        url: `${API_VERSION.V1}/${ACCOUNTS_URL}`,
        method: 'PUT',
        body: body,
      }),
      async onQueryStarted({ projectId }, { dispatch, queryFulfilled }) {
        try {
          const { data: updatedAccount } = await queryFulfilled;
          dispatch(
            accountsService.util.updateQueryData('getAccounts', undefined, (draft) => {
              Object.assign(draft, updatedAccount);
            }),
          );
        } catch {}
      },
    }),
  }),
});

export const { useGetAccountsQuery, useUpdateAccountsMutation, useLazyGetAccountsQuery } =
  accountsService;
